import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Markdown } from "@/components/chat/Markdown";
import { ChevronDown, Info } from "lucide-react";

const cache = {};
export const resetTextsCache = () => { Object.keys(cache).forEach((k) => delete cache[k]); };

export function useSiteTexts(persona) {
  const p = persona === "postgraduate" ? "postgraduate" : "undergraduate";
  const [texts, setTexts] = useState(null);
  useEffect(() => {
    cache[p] = cache[p] || api.get("/texts", { params: { persona: p } }).then((r) => r.data).catch(() => { delete cache[p]; return null; });
    cache[p].then(setTexts);
  }, [p]);
  return texts;
}

export function ToolIntro({ textKey, persona }) {
  const texts = useSiteTexts(persona);
  const storeKey = `elite_intro_collapsed_${textKey}`;
  const [open, setOpen] = useState(() => {
    const v = localStorage.getItem(storeKey);
    return v === null ? window.innerWidth >= 768 : v !== "1"; // collapsed by default on mobile
  });
  const t = texts?.[textKey];
  if (!t) return null;
  const toggle = () => { localStorage.setItem(storeKey, open ? "1" : "0"); setOpen(!open); };
  return (
    <div className="border-b border-border bg-white px-5 py-3 shrink-0" data-testid={`tool-intro-${textKey}`}>
      <button onClick={toggle} data-testid={`tool-intro-toggle-${textKey}`} className="w-full flex items-center gap-2 text-left">
        <Info className="h-4 w-4 text-orange shrink-0" />
        <span className="flex-1 text-sm font-bold text-navy">{t.title}</span>
        <span className="text-[11px] font-semibold text-muted-foreground">{open ? "Hide" : "How it works"}</span>
        <ChevronDown className={`h-4 w-4 text-muted-foreground transition-transform ${open ? "rotate-180" : ""}`} />
      </button>
      {open && (
        <div className="mt-2 pl-6 max-w-3xl [&_strong]:text-navy [&_ul]:list-disc [&_ul]:pl-4 [&_li]:my-0.5" data-testid={`tool-intro-body-${textKey}`}>
          <Markdown className="text-sm text-muted-foreground">{t.body}</Markdown>
        </div>
      )}
    </div>
  );
}
